import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const RESIZE_HOST = /^https:\/\/[^/]+\.emergentagent\.(net|com)\//;
const MEDIA_FILE = /^\/api\/(media\/[^/]+\/file|vouchers\/backgrounds\/[a-z]+)$/;

// `w` requests a resized WebP display copy (original kept untouched on the server).
export const mediaUrl = (u, w) => {
  if (!u) return "";
  const base = process.env.REACT_APP_BACKEND_URL;
  if (w && MEDIA_FILE.test(u)) return `${base}${u}?w=${w}`;
  if (w && RESIZE_HOST.test(u)) return `${API}/img?src=${encodeURIComponent(u)}&w=${w}`;
  return u.startsWith("http") ? u : `${base}${u}`;
};

export const mediaSrcSet = (u, widths = [320, 640, 1280]) =>
  u && (MEDIA_FILE.test(u) || RESIZE_HOST.test(u)) ? widths.map((w) => `${mediaUrl(u, w)} ${w}w`).join(", ") : undefined;

let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error.config;
    const isSessionRoute = request?.url?.startsWith("/auth/");
    if (error.response?.status !== 401 || request?._retried || isSessionRoute) return Promise.reject(error);
    request._retried = true;
    try {
      refreshPromise ||= api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      await refreshPromise;
      return api(request);
    } catch {
      return Promise.reject(error);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) => `\u20B9${Number(n).toLocaleString("en-IN")}`;
